import { format, parseISO } from "date-fns";
import type { Locale } from "date-fns";

import type { FinanceColors } from "./useFinanceColors";

// Entity colors come from useFinanceColors: an entity keeps its color on every chart

/** Recessive axes and grid in the theme colors (concrete values, see useFinanceColors) */
export const buildNivoTheme = (colors: FinanceColors) => ({
  text: { fill: colors.text, fontSize: 11 },
  axis: {
    ticks: {
      line: { stroke: "transparent" },
      text: { fill: colors.text, fontSize: 11 },
    },
    domain: { line: { stroke: "transparent" } },
  },
  grid: { line: { stroke: colors.grid, strokeWidth: 1 } },
  crosshair: { line: { stroke: colors.text, strokeWidth: 1 } },
});

/** Space between adjacent fills (2px surface gap) */
export const BAR_GAP = 2;
export const BAR_RADIUS = 4;

/** Short month label of a `YYYY-MM-01` month, e.g. "out 26" */
export const monthLabel = (month: string, locale: Locale): string =>
  format(parseISO(month), "MMM yy", { locale });
